import { render, staticRenderFns } from "./tabISF10.vue?vue&type=template&id=5a337b4c&scoped=true&"
import script from "./tabISF10.vue?vue&type=script&lang=js&"
export * from "./tabISF10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a337b4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a337b4c')) {
      api.createRecord('5a337b4c', component.options)
    } else {
      api.reload('5a337b4c', component.options)
    }
    module.hot.accept("./tabISF10.vue?vue&type=template&id=5a337b4c&scoped=true&", function () {
      api.rerender('5a337b4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/tabISF10.vue"
export default component.exports